'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigate = exports.Redirect = exports.Route = exports.Router = undefined;

var _router = require('./router');

var _router2 = _interopRequireDefault(_router);

var _route = require('./route');

var _route2 = _interopRequireDefault(_route);

var _redirect = require('./redirect');

var _redirect2 = _interopRequireDefault(_redirect);

var _navigate2 = require('./navigate');

var _navigate3 = _interopRequireDefault(_navigate2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Router = _router2.default;
/**
 * Expose `Router`, `Route` and `navigate`.
 */

exports.Route = _route2.default;
exports.Redirect = _redirect2.default;
exports.navigate = _navigate3.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJSb3V0ZXIiLCJSb3V0ZSIsIlJlZGlyZWN0IiwibmF2aWdhdGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7UUFLT0EsTTtBQUpQOzs7O1FBS09DLEs7UUFDQUMsUTtRQUNBQyxRIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiXG4vKipcbiAqIEV4cG9zZSBgUm91dGVyYCwgYFJvdXRlYCBhbmQgYG5hdmlnYXRlYC5cbiAqL1xuXG5leHBvcnQgUm91dGVyIGZyb20gJy4vcm91dGVyJ1xuZXhwb3J0IFJvdXRlIGZyb20gJy4vcm91dGUnXG5leHBvcnQgUmVkaXJlY3QgZnJvbSAnLi9yZWRpcmVjdCdcbmV4cG9ydCBuYXZpZ2F0ZSBmcm9tICcuL25hdmlnYXRlJ1xuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/deku-enroute/lib/index.js
// module id = 389
// module chunks = 0